import { render, staticRenderFns } from "./candidate-job-experience-items.vue?vue&type=template&id=6623419a&"
import script from "./candidate-job-experience-items.vue?vue&type=script&lang=js&"
export * from "./candidate-job-experience-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports